module.exports = __webpack_public_path__ + "img/ARCO.7b3ee5e2.svg";